import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { financialForeclosureItemValidator } from './validators/item';
import { FinancialForeclosureModel } from './types';

const financialForeclosureValidator: ValidateJSModel<FinancialForeclosureModel> = {
  HasForeclosure: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasForeclosure?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialForeclosureItemValidator },
      };
    }

    return {};
  },
};

export default financialForeclosureValidator;
